import React from "react";
import { LearningRecordSimulation, SimulationAssessmentReport, SimulationTranscript } from "src/types/coaching/learners";

export interface SimulationContextProps {
  id?: string;

  view: "summary" | "simulator" | 'completion' | "report" | "failed" | "call-recording";
  secondaryView?: null | "call-recording" | "call-recording-minimized";
  startingSimulation?: boolean;
  enrollingSimulation?: boolean;
  endingSimulation?: boolean;
  restartingSimulation?: boolean;
  retakingSimulation?: boolean;

  fetchingReport?: boolean;
  fetchedReport?: boolean;

  assessmentReport?: SimulationAssessmentReport;

  fetchingTranscripts?: boolean;
  fetchedTranscripts?: boolean;

  transcripts?: SimulationTranscript[];

  // eslint-disable-next-line no-unused-vars
  changeView? : (view: "summary" | "simulator" | 'completion' | "report" | "failed") => void;

  // eslint-disable-next-line no-unused-vars
  changeSecondaryView? : (view: null | "call-recording" | "call-recording-minimized") => void;

  enrollSimulation?: () => void;
  startSimulation?: () => void;
  retakeSimulation?: () => void;
  restartSimulation?: () => void;
  resumeSimulation?: () => void;
  // eslint-disable-next-line no-unused-vars
  endSimulation?: (simulation: LearningRecordSimulation) => void;

  viewReport?: () => void;
  fetchTranscripts?: () => void;

  // eslint-disable-next-line no-unused-vars
  onBack?: () => void;
}

export const SimulationContext = React.createContext<SimulationContextProps>({
  view: "summary",
});